import { BoldMarkSpec, BOLD_KEY } from '@techchange/pm-specs';

import BoldButton from './components/BoldButton';
import boldKeymap from './plugins/keymap';

const bold = {

	marks() {

		return {
			[BOLD_KEY]: BoldMarkSpec,
		};

	},

	plugins() {

		return [boldKeymap];

	},

	toolbarButtons() {

		return [{ Button: BoldButton, key: 'BoldButton' }];

	},

};

export default bold;
